import { ChangeDetectionStrategy, Component, input } from "@angular/core";

import { NotificationType } from "../../../../../../apis/networkdashboard/graphql/graphql";
import { services } from "../../../../../../app/services";
import { MalfunctionItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/malfunction/malfunction-item";
import { SendConfigItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/send-config/send-config-item";
import { ServiceDocumentationItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/service-documentation/service-documentation";
import { ShortcutMenu } from "../../../../../../components/subscription-detail/shortcut-menu/shortcut-menu";
import { ProductType } from "../../../../../../helpers/enums/productType";

@Component({
  selector: "port-shortcut-menu",
  templateUrl: "port-shortcut-menu.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MalfunctionItem, SendConfigItem, ServiceDocumentationItem, ShortcutMenu],
})
export class PortShortcutMenu {
  protected subscription = input.required<{
    status: string;
    endDate?: number | null;
    subscriptionId: string;
    product: { type: string };
  }>();
  protected activities = input.required<NotificationType[]>();

  protected readonly serviceDocumentationUrl = services[ProductType.Port].docs;
}
